import { render } from "./EstadoForm.vue?vue&type=template&id=54806390&scoped=true"
import script from "./EstadoForm.vue?vue&type=script&lang=js"
export * from "./EstadoForm.vue?vue&type=script&lang=js"

import "./EstadoForm.vue?vue&type=style&index=0&id=54806390&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54806390"]])

export default __exports__